import React, { Component, Fragment } from 'react';
import { RedoOutlined } from '@ant-design/icons';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { Table, Spin, Row, Col, Popover, Tooltip } from 'antd';
import { getNetExtensionData } from '../../../services/Cascade/Impedance';
import _ from 'lodash'

const columns = [
  {
    title: 'Port',
    dataIndex: 'port',
    width: '10%',
  }, {
    title: 'Eq. Pwr Pin',
    dataIndex: 'powerPin',
    width: '30%',
  }, {
    title: 'Eq. Gnd Pin',
    dataIndex: 'groundPin',
    width: '30%',
  }, {
    title: 'Component',
    dataIndex: 'VRM_COMP',
    width: '30%'
  }
]

class VRMPinGroupPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      VRMInfoMap: {},
      VRMPorts: [],
      selectedKeysMap: {},
      mergeVisible: {}
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount = () => {
    this.initColumns();
    this.initVRMPorts();
  }

  componentDidUpdate(prevProps) {
    const { noPCB, data = [] } = this.props;
    if (noPCB !== prevProps.noPCB || data.length !== prevProps.data.length) {
      this.initColumns()
      this.initVRMPorts();
    }
  }

  initColumns = () => {

    columns[1].render = (text = []) => {
      return <div className="cascade-vrm-pin-content">
        <span>{text.map(item => item && item.comp ? `${item.comp} - ${item.pins.join(', ')}` : '').join('; ')}</span>
      </div>
    }

    columns[2].render = (text = []) => {
      return <div className="cascade-vrm-pin-content">
        <span>{text.map(item => item && item.comp ? `${item.comp} - ${item.pins.join(', ')}` : '').join('; ')}</span>
      </div>
    }

    columns[3].render = (text = []) => {
      return (
        <div style={{ position: 'relative', minHeight: 20 }}>
          <span>{text ? text.join(', ') : ''}</span>
        </div>
      );
    }
  }

  initVRMPorts = () => {
    const { data, pcbId, currentDesignId, layouts } = this.props
    let VRMInfoMap = {}, _VRMPorts = []
    const netExtensionData = getNetExtensionData(layouts, pcbId) || {}
    const extensionNets = netExtensionData[currentDesignId] || []
    data.forEach(record => {
      const { MAIN_POWER_NETS, VRM, VRMPorts = [] } = record;
      const powerNet = MAIN_POWER_NETS && MAIN_POWER_NETS.length ? MAIN_POWER_NETS[0] : ''
      if (!extensionNets.includes(powerNet)) {
        VRMInfoMap[powerNet] = VRM
        if (VRMPorts.length) {
          _VRMPorts.push({ powerNet, ports: [...VRMPorts] })
        } else {
          _VRMPorts.push({ powerNet, ports: VRM.map((item, index) => { return { port: index + 1, powerPin: item.powerPin, groundPin: item.groundPin, VRM_COMP: item.VRM_COMP } }) })
        }
      }
    })
    this.setState({
      VRMInfoMap,
      VRMPorts: _VRMPorts,
      loading: false,
    })
  }

  resetPinGroup = (e, powerNet) => {
    e.stopPropagation();
    const { VRMInfoMap, VRMPorts, selectedKeysMap, mergeVisible } = this.state
    let _VRMPorts = [...VRMPorts]
    const findIndex = _VRMPorts.findIndex(item => item.powerNet === powerNet)
    if (findIndex < 0) return
    const prevPorts = JSON.parse(JSON.stringify(_VRMPorts[findIndex].ports))
    const VRMInfo = VRMInfoMap[powerNet] || []
    const ports = VRMInfo.map((item, index) => {
      return {
        port: index + 1,
        powerPin: item.powerPin,
        groundPin: item.groundPin,
        VRM_COMP: item.VRM_COMP
      }
    })
    _VRMPorts[findIndex].ports = ports

    _VRMPorts.forEach(item => {
      if (item.powerNet === powerNet) return;
      let match = item.ports.find(port => {
        const match = prevPorts.find(op => _.isEqual(op.powerPin, port.powerPin) && _.isEqual(op.groundPin, port.groundPin));
        return match
      });
      if (match) {
        //reset
        const newVRMInfo = VRMInfoMap[item.powerNet] || []
        const newPorts = newVRMInfo.map((item, index) => {
          return {
            port: index + 1,
            powerPin: item.powerPin,
            groundPin: item.groundPin,
            VRM_COMP: item.VRM_COMP
          }
        })
        item.ports = newPorts
      }
    });

    selectedKeysMap[powerNet] = []
    mergeVisible[powerNet] = false
    this.setState({
      VRMPorts: _VRMPorts,
      selectedKeysMap,
      mergeVisible
    })
  }

  closeModal = () => {
    const { VRMPorts } = this.state
    const { currentDesignId } = this.props
    this.props.saveVRMPorts(currentDesignId, VRMPorts)
    this.props.closePanel()
  }

  rowSelectionChange = (powerNet, selectedRowKeys) => {
    const { selectedKeysMap, mergeVisible } = this.state
    selectedKeysMap[powerNet] = selectedRowKeys;
    mergeVisible[powerNet] = selectedRowKeys.length > 1 ? true : false
    this.setState({
      selectedKeysMap,
      mergeVisible
    });
  };

  getRowSelection = (powerNet) => {
    const { selectedKeysMap, mergeVisible } = this.state
    const selectedRowKeys = selectedKeysMap[powerNet] || [];
    const selectedPort = selectedRowKeys && selectedRowKeys.length ? selectedRowKeys[0] : null;
    return {
      selectedRowKeys,
      onChange: (selectedKeys) => this.rowSelectionChange(powerNet, selectedKeys),
      renderCell: (checked, record, index, originNode) => {
        const port = record.port;
        const showPopover = mergeVisible[powerNet] && selectedPort === port;
        return showPopover ? (
          <Popover
            classNames={{ root: "merge-path-popover" }}
            content={
              <span onClick={(e) => this.mergeGroup(e, powerNet)}>
                Merge Port
              </span>
            }
            placement="topRight"
            open={true}
            getPopupContainer={() =>
              document.getElementById(`impedance-vrm-checkbox-${port}`)
            }
          >
            <span id={`impedance-vrm-checkbox-${port}`}>{originNode}</span>
          </Popover>
        ) : (
          originNode
        );
      },
    };
  };

  mergeGroup = (e, powerNet) => {
    e.stopPropagation()
    const { selectedKeysMap, VRMPorts, mergeVisible } = this.state
    const selectedPorts = selectedKeysMap[powerNet];
    if (!selectedPorts || selectedPorts.length < 2) return;
    const _VRMPorts = [...VRMPorts]
    const findIndex = _VRMPorts.findIndex(item => item.powerNet === powerNet);
    if (findIndex < 0) return;

    const merged = { port: '', powerPin: [], groundPin: [], VRM_COMP: [] };
    const newPorts = [];
    let i = 1, mergedDone = false;
    const originalPins = [];
    for (const row of _VRMPorts[findIndex].ports || []) {
      if (selectedPorts.includes(row.port)) {
        merged.powerPin.push(...(row.powerPin || []));
        merged.groundPin.push(...(row.groundPin || []));
        merged.VRM_COMP.push(...(row.VRM_COMP || []));
        originalPins.push({ powerPin: row.powerPin || [], groundPin: row.groundPin || [] });
        if (!mergedDone) {
          merged.port = i++;
          newPorts.push(merged);
          mergedDone = true;
        }
      } else {
        newPorts.push({ ...row, port: i++ });
      }
    }
    _VRMPorts[findIndex].ports = newPorts;

    _VRMPorts.forEach(item => {
      if (item.powerNet === powerNet) return;
      const newPorts = [];
      let mergedOnce = false;
      item.ports.forEach((port, index) => {
        const match = originalPins.find(op =>
          port.powerPin.some(pin => op.powerPin.find(_pin => _pin.comp === pin.comp && _.isEqual(_pin.pins, pin.pins))) &&
          port.groundPin.some(pin => op.groundPin.find(_pin => _pin.comp === pin.comp && _.isEqual(_pin.pins, pin.pins)))
        );
        if (match) {
          if (!mergedOnce) {
            newPorts.push({ ...merged, port: index + 1 });
            mergedOnce = true;
          }
        } else {
          newPorts.push(port);
        }
      });
      item.ports = newPorts;
    });

    selectedKeysMap[powerNet] = []
    mergeVisible[powerNet] = false
    this.setState({
      VRMPorts: _VRMPorts,
      selectedKeysMap,
      mergeVisible,
    })
  }

  renderDialog = () => {
    const { loading, VRMPorts } = this.state;
    const content = (
      <Panel
        className='impedance-vrm-pin-group-panel'
        id='impedance-vrm-pin-group-panel'
        title={'VRM Ports Grouping'}
        onCancel={this.closeModal}
        zIndex={2000}
        width={1000}
        minWidth={200}
        minHeight={200}
        position='panel-center-left'
        draggable
        overflow={"auto"}
        maxHeight={1000}
      >
        <Spin spinning={loading} tip="Loading...">
          <div className='impedance-vrm-pin-group-body'>
            {VRMPorts.map((item, index) => {
              return (
                <div className='impedance-vrm-pin-group-content' key={index}>
                  <Row className='impedance-vrm-pin-group-row'>
                    <Col className='impedance-vrm-pin-group-setup-border'>
                      <span className='font-bold cascade-setup-title-color'>
                        {item.powerNet}
                        <Tooltip
                          title='Reset port'
                          classNames={{ root: "aurora-tooltip" }}
                        >
                          <RedoOutlined className='impedance-comp-add-icon' onClick={(e) => this.resetPinGroup(e, item.powerNet)} />
                        </Tooltip>
                      </span>
                      <div className='space-10'>
                        <Table
                          rowKey={(record) => { return record.port }}
                          columns={columns}
                          dataSource={item.ports}
                          size="small"
                          rowSelection={this.getRowSelection(item.powerNet)}
                          bordered
                          pagination={false}
                          tableLayout="fixed"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>)
            })}
          </div>
        </Spin>
      </Panel>
    );
    return createPortal(content, this.dialogRoot);
  }

  render() {
    return <Fragment>
      {this.renderDialog()}
    </Fragment>
  }
}

export default VRMPinGroupPanel;
